document.addEventListener("DOMContentLoaded", function () {
    function updateButtons(contentId, isSaved, contentTypeId) {
        let contentTypeName;

        switch (contentTypeId) {
            case ContentType.Article:
                contentTypeName = "article";
                break;
            case ContentType.Tool:
                contentTypeName = "tool";
                break;
        }

        document.querySelectorAll(`.save-button[data-contentitemid="${contentId}"]`).forEach(btn => {
            const img = btn.querySelector("img");
            const label = btn.querySelector(".save-label");

            if (isSaved) {
                img.src = "/img/icons/save-fill.svg";
                label.textContent = "Saved";
                btn.classList.add("saved");
                btn.classList.remove("save");
                btn.title = `Unsave this ${contentTypeName} from my profile`;
                btn.setAttribute("aria-label", `Unsave this ${contentTypeName} from my profile`);
            } else {
                img.src = "/img/icons/save.svg";
                label.textContent = "Save";
                btn.classList.add("save");
                btn.classList.remove("saved");
                btn.title = `Save this ${contentTypeName} to my profile`;
                btn.setAttribute("aria-label", `Save this ${contentTypeName} to my profile`);
            }
        });
    }

    function handleSaveToggleFailure(contentItemId, isSaved, contentTypeId) {
        showToast("Something went wrong. Refresh the page and try again.", NaN, "fail");
        updateButtons(contentItemId, isSaved, contentTypeId);
    }

    document.querySelectorAll(".save-button").forEach(button => {
        if (!button.dataset.loggedIn || button.dataset.loggedIn === "false") {
            const redirectUrl = new URL(window.location.href);
            button.dataset.href = redirectUrl.pathname + redirectUrl.search;
        }
    });

    document.querySelectorAll(".save-button").forEach(button => {
        button.addEventListener("click", function (e) {
            const isLoggedIn = this.dataset.loggedIn === "true";
            const contentItemId = this.dataset.contentitemid;
            const contentTypeId = parseInt(this.dataset.contenttypeid) || 0;

            if (!isLoggedIn) {
                e.preventDefault();
                const target = e.target.closest("[data-action]");
                const redirectUrl = target.dataset.href;
                openLoginAccessDenied(null, redirectUrl, true, "Please log into your account now to access this feature.");
                return;
            }

            const isSaved = this.querySelector("img").src.includes("save-fill");
            updateButtons(contentItemId, !isSaved, contentTypeId);

            if (contentItemId && contentTypeId) {
                (async () => {
                    try {
                        const response = await fetch("/item/toggle-save", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "RequestVerificationToken": $('input:hidden[name="__RequestVerificationToken"]').val()
                            },
                            body: JSON.stringify({
                                contentItemId: contentItemId,
                                contentTypeId: contentTypeId
                            })
                        });

                        if (!response.ok) {
                            handleSaveToggleFailure(contentItemId, isSaved, contentTypeId);
                        }
                    } catch (error) {
                        handleSaveToggleFailure(contentItemId, isSaved, contentTypeId);
                    }
                })();
            }
            else {
                handleSaveToggleFailure(contentItemId, isSaved, contentTypeId);
            }
        });
    });
});